import { LanguageHrefMap, NavigationItemForAllLanguages, NavigationItem, SupportedHeaderLanguage } from './types';
import { supportedHeaderLanguages } from './header';

export function convertToNavigationItem(item: NavigationItemForAllLanguages, language: SupportedHeaderLanguage): NavigationItem {
  const subs = item.subs?.reduce<NavigationItem[]>((acc, subItem) => {
    if (isNavigationItemSupportCurrentLanguage(subItem, language)) {
      acc.push(convertToNavigationItem(subItem, language));
    }
    return acc;
  }, []);
  const href = getHrefByLanguage(item.href, language);
  return {
    ...item,
    href,
    subs,
  };
}

export function getHrefByLanguage(hrefMap: LanguageHrefMap | undefined, language: SupportedHeaderLanguage): string | undefined {
  if (typeof hrefMap === 'string' || !hrefMap) {
    return hrefMap;
  }
  return hrefMap[language] || 'no-link';
}

export function isSupportedLanguage(language: string): language is SupportedHeaderLanguage {
  return supportedHeaderLanguages.includes(language as SupportedHeaderLanguage);
}

export function isNavigationItemSupportCurrentLanguage(item: NavigationItemForAllLanguages, language: SupportedHeaderLanguage) {
  return !item.lang || item.lang.includes(language);
}
